import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import {UnitRatingResponse} from '../../../model/unit-rating-response';
import {ModelService} from '../../../services/model-service';
import {SelectionUtils} from '../../selection-utils';
import {UnitConversionUtils} from '../../unit-conversion-utils';
import {ConfigurationSection, UserStateService} from '../../../services/user-state.service';
import { HeatingOnlyPerformanceInputComponent } from '../heating-only-performance-input/heating-only-performance-input.component';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-cabinet-unit-heater-performance-input',
    templateUrl: './cabinet-unit-heater-performance-input.component.html',
    styleUrls: ['./cabinet-unit-heater-performance-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule, HeatingOnlyPerformanceInputComponent]
})
export class CabinetUnitHeaterPerformanceInputComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly ratingResponse = input.required<UnitRatingResponse>();
  readonly valueChanged = output<void>();
  readonly inputUnitsChanged = output<void>();
  fanSpeedSelection!: GuruEntity;
  espSelection!: GuruEntity;
  altitudeSelection!: GuruEntity;
  inputTypeSelection!: GuruEntity;
  ecoAirflowSelection!: GuruEntity;
  isExpanded = true;
  isMetric = false;
  ratingResponseError!: string;
  private sectionKey = ConfigurationSection.PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.fanSpeedSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFSpeed');
    this.espSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFESP');
    this.altitudeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAltitude');
    this.inputTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMetricInput');
    this.isMetric = this.inputTypeSelection && 'true' === this.inputTypeSelection.Value;
    this.ecoAirflowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFAirflow');
    if (this.ratingResponse()) {
      this.ratingResponseError = this.ratingResponse().ErrorMessage;
    }
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

  getPressureMeasurementUnits(): string {
    return UnitConversionUtils.getEspUnits(this.isMetric);
  }

  getDistanceMeasurementUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.isMetric);
  }

  getAirflowMeasurementUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric);
  }

  inputTypeChanged(newValue: string): void {
    this.modelService.setValue(this.inputTypeSelection.Name, this.engineKey(), newValue).subscribe(() => this.inputUnitsChanged.emit());
  }

  performanceValueChanged(): void {
    this.valueChanged.emit();
  }

}
